<template>
  <div style="margin-top:70px;margin-bottom:40px;">
    <div class = "molBox">
    <div class="menu">
      <legend style="font-size:25px;line-height:45px;color:cadetblue;background:#E6E6E6;text-align:center;height:45px;">Parameters Set</legend>
    <div style="padding-left:22px; padding-top:50px;">
      <h3>Chain :</h3>
      <input type="button" value="Cartoon"  @click="cartoon()">
      <input type="button" value="Line"  @click="line()">
      <input type="button" value="Stick"  @click="stick()">
      <input type="button" value="Cross"  @click="cross()">
      <input type="button" value="Sphere"  @click="sphere()">
      <input type="button" value="Metal-site"  @click="metal()">
       <h3>Metal-binding Site:</h3>
      <input type="button" value="Zoom"  @click="zoom()">
      <input type="button" value="Recenter"  @click="wdzoom()">
      <h3>background:</h3>
      <input type="button" value="white"  @click="white()">
      <input type="button" value="black"  @click="black()">
      <input type="button" value="grey"  @click="grey()">
      <input type="button" value="orange"  @click="orange()">
      <input type="button" value="red"  @click="red()">
      <input type="button" value="green"  @click="green()">
      <input type="button" value="blue"  @click="blue()">
      <input type="button" value="purple"  @click="purple()">
    </div>

    <br>
    <br>
  </div>
    <div class="mol">
      <div class="title">
         <legend style="width: 600px;line-height:45px;font-size:25px;color:white;background:#5E6973;text-align:center;height:45px;margin-bottom:40px;"> 3D View: Structure</legend>
      </div>
    <div id="container-01" class="mol-container">
  </div>
    </div>
  </div>
  <h1></h1>
  <el-table
        :data="txt"
        border
        stripe
      >
        <el-table-column
          type="index"
          label="#"
        ></el-table-column>
        <el-table-column label="Residue Number" prop="nb">
        </el-table-column>
          <el-table-column label="Residue" prop="residue"></el-table-column> 
        <el-table-column label="Atom" prop="atom"></el-table-column>
        <el-table-column label="Atom Number" prop="atom_nb"></el-table-column>
         <el-table-column label="Metal" prop="metal"></el-table-column>
         <el-table-column label="Distance" prop="distance"></el-table-column>
        <el-table-column label="Metal Number" prop="metal_nb"></el-table-column>
         
         
      </el-table>
  </div>
</template>

<script>
// import 'jquery';

//import("3dmol/build/3Dmol-min.js")
export default {
  mounted() {
    this.onSubmit()
    // this.cavas();
  },
  data() {
    return {
       pdb: '',
       pos:'',
       ion:'',
       site:'',
       hoh:'',
       bc:'white',
       shape:'cartoon',
       flag:0,
       txt:[]
    }},
  methods: {
    white(){
      this.bc = "white"
      this.cavas();
    },
    black(){
this.bc = "black"
      this.cavas();
    },
    orange(){
this.bc = "orange"
      this.cavas();
    },
    grey(){
this.bc = "grey"
      this.cavas();
    },
    zoom(){
this.flag = 1
      this.cavas();
    },
    wdzoom(){
this.flag = 0
      this.cavas();
    },
     stick(){
this.shape = "stick"
      this.cavas();
    },
    line(){
this.shape = "line"
      this.cavas();
    },
     cartoon(){
this.shape = "cartoon"
      this.cavas();
    },
     cross(){
this.shape = "cross"
      this.cavas();
    },
    sphere(){
this.shape = "sphere"
      this.cavas();
    },
    metal(){
this.shape = "surface"
      this.cavas();
    },
    red(){
this.bc = "red"
      this.cavas();
    },
    green(){
this.bc = "green"
      this.cavas();
    },
    blue(){
this.bc = "blue"
      this.cavas();
    },
    purple(){
this.bc = "purple"
      this.cavas();
    },
    //
//3dmol
cavas(){
  let element = $("#container-01");
    let config = { backgroundColor: this.bc };
    let viewer = $3Dmol.createViewer(element, config);
    var pdb = this.pdb
    var pos = this.pos;
    var ion = this.ion;
    var site = this.site;
    var hoh = this.hoh;
    var shape = this.shape;
    var flag = this.flag;
     

 $3Dmol.download("pdb:"+pdb, viewer, {},function () {

   var chain = ["A", "B", "C", "D", "E", "F",'G','H','I','J','K','O'];
   
   for (
        var i = 0;
        i < chain.length;
        i++ 
      ) {
        if (chain[i] == pos) {
          viewer.setStyle({ chain: pos }, { [shape+""]: { color: "spectrum" } });
        } else {
          // viewer.setStyle({ chain: pos }, { cartoon: { color: "spectrum" } });
          viewer.addResLabels({chain: pos,resi:site}, {font: 'Arial',fontSize:12, fontColor:'black',showBackground:false});
          viewer.setStyle({ chain: chain[i] }, { cross: { hidden: true } });
          // viewer.setStyle({ chain: chain[i] }, { [shape+""]: { color: "spectrum" } });
        }
      }
      for(var k=0;k<ion.length;k++){
        viewer.setStyle({chain: pos,resn: ion[k]},{sphere:{radius:0.5,color:'red'}});
      }

    // viewer.setStyle({chain:'B'},{cross:{hidden:true}});
      viewer.setStyle({chain: pos,resi:site},{stick:{color:'blue'}});
// viewer.addResLabels({chain: pos,resi:site}, {font: 'Arial',fontSize:10, fontColor:'black',showBackground:false});
viewer.setStyle({chain: pos,resi: hoh},{sphere:{radius:0.2}});
viewer.addResLabels({chain: pos,resn: ion}, {font: 'Arial',fontSize:10, fontColor:'orange',showBackground:false});

if (flag == 1) {
         viewer.zoomTo({chain: pos,resn: ion});
         viewer.render();
        }else{viewer.render();};
        
 })
},
  //3dmol
 async onSubmit() {
   var url = window.location.href.slice(-6);
      const res = await this.$http.get("chaincodes", { params: {search:url.slice(0,4)+"_"+url.slice(5)}});
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      var data = res.data.results[0];
      this.txt = eval(data["txt"]);
      console.log(this.txt,typeof this.txt)
      this.pdb = data["pdb"].toUpperCase();
    this.pos = data["chain"].toUpperCase();
    this.ion = eval(data['metal'].toUpperCase());
    this.site = eval(data['site']);
    this.hoh = eval(data['hoh']);
      this.cavas();
      
    },
  },
  
};

 
</script>

<style scoped>
.molBox{
  margin: auto;
  width:1070px;
  display: flex;
  flex-direction: row;
}
.mol {
  width: 600px;
  height: 580px;
  border: 1px solid #DCDCDC;
  display: flex;
  flex-direction:column;
  justify-content: center;
}

.mol-container {
  margin-bottom: 30px;
  width: 600px;
  height: 560px;
  position: relative;
}
.menu{
  width: 400px;
  height: 580px;
  border: 0.1px solid #DCDCDC;
  background-color: white;
  margin-right:30px;
  margin-left:20px;
  /* margin: auto; */
}
input{
  padding-right: 3px;
  scroll-padding-left: 3px;
  margin-right:7px ;
  width:67px;
  height: 33px;
}

</style>